import Icon from 'components/icons';
import InputMultiEmails from 'components/inputMultiEmails';
import { SELECT_USERS_COPY, removeChipLabel } from 'constants/invites';
import { Chip, ChipList } from 'pages/Users/components/InviteUsers/AddByLink/styles';
import UserPicker from './UserPicker';
import { ISelectUsersStep } from './types';
import {
  OrDivider,
  Section,
  SectionDescription,
  SectionHelper,
  SectionTitle,
  SelectStep,
} from './styles';

const SelectUsersStep: React.FC<ISelectUsersStep> = ({
  users,
  usersStatus,
  selectedUsers,
  onToggleUser,
  onRemoveUser,
  emails,
  setEmails,
  managedTeamsOnly,
}) => (
  <SelectStep>
    <Section>
      <SectionTitle>{SELECT_USERS_COPY.EXISTING_USERS_TITLE}</SectionTitle>
      <UserPicker
        users={users}
        status={usersStatus}
        selectedIds={selectedUsers.map(({ id }) => id)}
        onToggleUser={onToggleUser}
        managedTeamsOnly={managedTeamsOnly}
      />
      {selectedUsers.length > 0 && (
        <ChipList role="list" aria-label={SELECT_USERS_COPY.SELECTED_USERS}>
          {selectedUsers.map(({ id, name, email }) => (
            <Chip key={id} role="listitem">
              <span>{name || email}</span>
              <button
                type="button"
                aria-label={removeChipLabel(name || email)}
                onClick={() => onRemoveUser(id)}
              >
                <Icon icon={'Close'} size={'small'} />
              </button>
            </Chip>
          ))}
        </ChipList>
      )}
    </Section>
    <OrDivider>{SELECT_USERS_COPY.OR}</OrDivider>
    <Section>
      <SectionTitle>{SELECT_USERS_COPY.EMAILS_TITLE}</SectionTitle>
      <SectionDescription>{SELECT_USERS_COPY.EMAILS_DESCRIPTION}</SectionDescription>
      <InputMultiEmails emails={emails} setEmails={setEmails} />
      <SectionHelper>{SELECT_USERS_COPY.EMAILS_HELPER}</SectionHelper>
    </Section>
  </SelectStep>
);

export default SelectUsersStep;
